module.exports = __webpack_public_path__ + "img/1492991495.4d6c85fc.jpg";